<template>
  <div data-v-abca6e38="" data-v-2ac6a5fc="" class="assets-wrap sdfdds" >

    <div data-v-abca6e38="" class="assets">
      <div data-v-abca6e38="" class="banner">
        <p data-v-abca6e38="">总金额(CNY)</p>
        <h1 data-v-abca6e38="">{{ $store.state.userInfo.balance }}</h1>
        <h2 style="margin-top: 8px; font-size: 14px" @click="transall">一键回收</h2>
        <div data-v-abca6e38="" v-if="shws" @click="openList" style="padding-top: 10px">点我收起</div>
        <div class="qiehuan" @click="changeTasfer" style="display: none;"><img src="/static/image/qie021213.png" alt="" />{{ $store.state.userInfo.transferstatus == 0 ? '转账模式' : '免转模式' }}</div>
      </div>
      <div data-v-abca6e38="" class="list-wrap">
        <div data-v-abca6e38="" class="list" style="display: none">
          <div data-v-abca6e38="" class="flex-group" v-for="(item, index) in balancelist" :key="index" style="box-sizing: border-box; padding: 5px; width: 33%; display: inline-block">
            <div data-v-abca6e38="" class="item">
              <p data-v-abca6e38="">{{ item.name }}</p>
              <p data-v-abca6e38="" class="platform-sum">{{ item.balance }}</p>
              <p><span class="btne" v-if="$store.state.userInfo.transferstatus == 0" @click="oneUpdate(item)">额度转换</span></p>
            </div>
          </div>
        </div>
        <div data-v-abca6e38="" class="arrow-down-wrap"><span data-v-abca6e38="" @click="openList" class="arrow-down"></span></div>
      </div>
      <div data-v-abca6e38=""  class="banner" style="padding: 10px;min-height: 0px;line-height: 1.8;">
        <van-row>
          <van-col :span="6">投注总额</van-col>
          <van-col :span="6">输赢总额</van-col>
          <van-col :span="6">有效投注</van-col>
          <van-col :span="6">投注总次</van-col>
        </van-row>
        <van-row style="color: rgb(204, 163, 82);font-weight: 700;font-size: 18px;">
          <van-col :span="6">{{ BetInfo.total_bet }}</van-col>
          <van-col :span="6">{{ BetInfo.total_win_loss }}</van-col>
          <van-col :span="6">{{ BetInfo.total_valid_bet }}</van-col>
          <van-col :span="6">{{ BetInfo.total_count }}</van-col>
        </van-row>
      </div>
      <div data-v-abca6e38="" class="content" >
        <div data-v-abca6e38="" class="list">
          <div data-v-abca6e38="" class="t">
            记录类型
            <span style="font-size: 10px; color: #999; font-weight: 100; padding-left: 10px">
            </span>
            <a data-v-abca6e38="" class="link" style="display: none">编辑</a>
          </div>
          <div data-v-abca6e38="" class="tab">
            <a data-v-abca6e38="" @click="changType(0)" :class="type == 0 ? 'active' : ''">存款</a>
            <a data-v-abca6e38="" @click="changType(1)" :class="type == 1 ? 'active' : ''">取款</a>
            <a data-v-abca6e38="" @click="changType(2)" :class="type == 2 ? 'active' : ''">转入</a>
            <a data-v-abca6e38="" @click="changType(3)" :class="type == 3 ? 'active' : ''">转出</a>
            <a data-v-abca6e38="" @click="changType(4)" :class="type == 4 ? 'active' : ''">投注</a>
            <a data-v-abca6e38="" @click="changType(5)" :class="type == 5 ? 'active' : ''">返水</a>
            <a data-v-abca6e38="" @click="changType(6)" :class="type == 6 ? 'active' : ''">奖金</a>
          </div>

          <el-select size="mini" v-model="api_type" placeholder="请选择平台" @change="changApiType">
            <el-option v-for="(item, index) in dogameLis" :key="index" :label="item.name" :value="item.platname"> </el-option>
          </el-select>
          <el-radio-group v-model="date" size="mini" fill="#fecb4d" @change="changApiType" style="margin: 12px auto">
            <el-radio-button label="1">今日</el-radio-button>
            <el-radio-button label="2">7日内</el-radio-button>
            <el-radio-button label="3">半月内</el-radio-button>
            <el-radio-button label="4">一月内</el-radio-button>
          </el-radio-group>
          <div v-if="type == 5" style="display: flex; align-items: center; justify-content: space-between; height: 30px" @click="lingqu">累计领取 {{ jisuan }} 待领取{{ nojisuan }} <span>点击领取</span></div>
          <div v-if="type == 6" style="display: flex; align-items: center; justify-content: space-between; height: 30px" @click="lingqu">累计领取 {{ jisuan }} </div>

          <div v-if="type == 0 || type == 1 || type == 2 || type == 3" data-v-73a82902="" data-v-3acb7497="" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="c">
            <div data-v-73a82902="" class="flex-group" v-for="(item, index) in list" :key="index">
              <div data-v-73a82902="" class="item" style="flex: 1; margin-right: 20px">
                <p data-v-73a82902="" class="txt-bold">
                  金额：{{ item.amount }}<span data-v-73a82902=" " style="float: right; color: #999">{{ item.created_at }}</span>
                </p>
                <p data-v-73a82902="" class="payType">{{ item.pay_way }}</p>
                <p data-v-73a82902="" v-if="type == 1 || type == 0">订单号：{{ item.out_trade_no }}</p>
              </div>
              <div data-v-73a82902="" class="item">
                <p data-v-73a82902="" class="status" v-if="type == 0">{{ stateType12[item.state] }}</p>
                <p data-v-73a82902="" class="status" v-if="type == 1">{{ stateType22[item.state] }}</p>
                <p data-v-73a82902="" class="status" v-if="type == 2 || type == 3">{{ stateType34[item.state] }}</p>
              </div>
            </div>
            <div data-v-abca6e38="" class="empty" v-if="list.length == 0">
              <div data-v-abca6e38="" class="icon-empty"></div>
              <p data-v-abca6e38="">暂无记录</p>
            </div>
            <div data-v-abca6e38="" class="empty" v-if="list.length != 0 && page==last_page" >
              <p data-v-abca6e38="">没有更多记录了</p>
            </div>
          </div>

          <div v-if="type == 4"  data-v-73a82902="" data-v-3acb7497="" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="c">
            <div data-v-73a82902="" class="flex-group" v-for="(item, index) in list4" :key="index">
              <div data-v-73a82902="" class="item" style="flex: 1; margin-right: 20px">
                <p data-v-73a82902="" class="txt-bold">
                  金额：{{ item.bet_amount }}<span data-v-73a82902=" " style="float: right; color: #999">{{ item.bet_time }}</span>
                </p>
                <p data-v-73a82902="" class="payType">
                  {{ item.Code }}<span data-v-73a82902=" " style="float: right; color: #999">派彩：{{ item.win_loss }}</span>
                </p>
                <p data-v-73a82902="">订单号：{{ item.bet_id }}</p>
              </div>
              <div data-v-73a82902="" class="item">
                <p data-v-73a82902="" class="status">{{ statuType[item.state] }}</p>
              </div>
            </div>
            <div data-v-abca6e38="" class="empty" v-if="list4.length == 0">
              <div data-v-abca6e38="" class="icon-empty"></div>
              <p data-v-abca6e38="">暂无记录</p>
            </div>
                        <div data-v-abca6e38="" class="empty" v-if="list4.length != 0 && page==last_page" >
              <p data-v-abca6e38="">没有更多记录了</p>
            </div>
          </div>
          <div v-if="type == 5" data-v-73a82902="" data-v-3acb7497="" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="c">
            <div data-v-73a82902="" class="flex-group" v-for="(item, index) in list5" :key="index">
              <div data-v-73a82902="" class="item" style="flex: 1; margin-right: 20px">
                <p data-v-73a82902="" class="txt-bold">
                  返水金额：{{ item.money }}<span data-v-73a82902=" " style="float: right; color: #999">{{ item.created_at }}</span>
                </p>
                <p data-v-73a82902="" class="payType">
                  {{ item.gamename }}
                </p>
                <p data-v-73a82902="">领取时间：{{ item.state == 0 ? '暂未领取' : item.updated_at }}</p>
              </div>
              <div data-v-73a82902="" class="item">
                <p data-v-73a82902="" class="status">{{ item.state == 0 ? '待领取' : '已领取' }}</p>
              </div>
            </div>
            <div data-v-abca6e38="" class="empty" v-if="list5.length == 0">
              <div data-v-abca6e38="" class="icon-empty"></div>
              <p data-v-abca6e38="">暂无记录</p>
            </div>
                        <div data-v-abca6e38="" class="empty" v-if="list5.length != 0 && page==last_page" >
              <p data-v-abca6e38="">没有更多记录了</p>
            </div>
          </div>
          <div v-if="type == 6" data-v-73a82902="" data-v-3acb7497="" infinite-scroll-disabled="busy" infinite-scroll-distance="10" class="c">
            <div data-v-73a82902="" class="flex-group" v-for="(item, index) in list5" :key="index">
              <div data-v-73a82902="" class="item" style="flex: 1; margin-right: 20px">
                <p data-v-73a82902="" class="txt-bold">
                  奖金金额：{{ item.money }}
                </p>
                <p data-v-73a82902="" class="payType">
                  {{ item.gamename }}
                </p>
                <p data-v-73a82902="">领取时间：{{ item.state == 0 ? '暂未领取' : item.updated_at }}</p>
              </div>
              <div data-v-73a82902="" class="item">
                <p data-v-73a82902="" class="status">{{ item.state == 0 ? '待领取' : '已领取' }}</p>
              </div>
            </div>
            <div data-v-abca6e38="" class="empty" v-if="list5.length == 0">
              <div data-v-abca6e38="" class="icon-empty"></div>
              <p data-v-abca6e38="">暂无记录</p>
            </div>
                        <div data-v-abca6e38="" class="empty" v-if="list5.length != 0 && page==last_page" >
              <p data-v-abca6e38="">没有更多记录了</p>
            </div>
          </div>
            <div style="height:50px"></div>

        </div>
      </div>

      <div data-v-abca6e38="" class="fixed-group" style="display: none">
        <div data-v-abca6e38="" class="checkbox">
          <input data-v-abca6e38="" type="checkbox" />
          <label data-v-abca6e38="" class="check">&nbsp;</label>
        </div>
        <span data-v-abca6e38="">全选</span><a data-v-abca6e38="">删除</a>
      </div>
    </div>
    <div data-v-710c460e="" data-v-0dc57850="" class="popup-background" @touchmove.prevent v-if="show">
      <div data-v-0dc57850="" data-v-710c460e="" class="safety-popup">
        <div data-v-0dc57850="" data-v-710c460e="" class="popup">
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-head">额度转换 <a data-v-0dc57850="" data-v-710c460e="" @click="hideShow" class="pop-close"></a></div>
          <div data-v-0dc57850="" data-v-710c460e="" class="pop-content">
            <p data-v-0dc57850="" data-v-710c460e="" class="hg">
              <span class="leftSpan">转换方式</span> <span :class="payType == 0 ? 'types active' : 'types '" @click="changVal('payType', 0)">转入</span><span :class="payType == 1 ? 'types active' : 'types '" @click="changVal('payType', 1)">转出</span><span style="flex: 1"></span>
            </p>
            <p data-v-0dc57850="" data-v-710c460e="" class="hg"><span class="leftSpan">账户余额</span><input class="" placeholder="平台账户余额" :value="$store.state.userInfo.balance" disabled /></p>
            <p data-v-0dc57850="" data-v-710c460e="" class="hg"><span class="leftSpan"> 游戏余额</span><input placeholder="游戏账户余额" :value="oneInfo.balance" disabled /></p>
            <p data-v-0dc57850="" data-v-710c460e="" class="hg"><span class="leftSpan">操作金额</span><input placeholder="请输入操作金额" v-model="amount" /></p>
            <a data-v-0dc57850="" data-v-710c460e="" @click="isOk()" class="button">确认</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'assets',
  data() {
    return {
   
      type: 0,
      list: [],
      list4: [],
      list5: [],
      page: 1,
      stateType12: ['待支付', '成功', '失败', '超时'],
      stateType22: ['','待审核','通过','拒绝'],
      statuType: ['无效注单', '已结算', '未结算'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
      last_page: 0,
      balancelist: [],
      daoTime: null,
      oneInfo: {},
      show: false,
      amount: null,
      payType: 0,
      shws: false,
      date: 4,
      dogameLis: [],
      api_type: '',
      jisuan: null,
      nojisuan: null,
      BetInfo:{}
    };
  },
  created() {
    let that = this;

if(!(that.$store.state.token && that.$store.state.userInfo.username && that.$store.state.userInfo.username.length > 0)){
      that.$router.push({ path: 'login' })
      return
    }

    that.page = 1;
    that.getdogame();

    var query = that.$route.query;
    if (query.type) {
      that.type = query.type;
    }
    let name = `getList${that.type}`;
    that[name]();
    that.getbalancelist();
    that.daoTime = setInterval(() => {
      that.getbalancelist();
    }, 3000);
  },
  methods: {
    lingqu() {
      let that = this;
      let fanshui = that.nojisuan;
      if (fanshui <= 0) {
        that.$parent.showTost(0, '暂无领取额度！');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/dofanshui', {})
        .then(res => {
          console.log(res);
          that.$parent.getUserInfoss();
          that.$parent.showTost(1, res.message);
          that.page = 1;
          that.getList5();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    transall() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.$parent.showTost(1, res.message);

          that.getbalancelist();

          that.refreshusermoney();
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    getdogame() {
      let that = this;

      that.$apiFun.post('/api/balancelist', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(res.message);
        }
        if (res.code == 200) {
          that.dogameLis = res.data;
          that.dogameLis.unshift({ name: '全平台', platname: '' });
        }
      });
    },
    changApiType() {
      let that = this;
      that.page = 1;
      let name = `getList${that.type}`;
      that[name]();
    },
    changeTasfer() {
      let that = this;
      that.$parent.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus == 0 ? 1 : 0;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.$parent.showTost(1, '操作成功！');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    isOk() {
      let that = this;
      let info = { amount: that.amount };
      if (that.amount == null) {
        that.$parent.showTost(0, '请输入操作金额！');
        return;
      }
      if (that.payType == 0) {
        info.sourcetype = 'userbalance'; 
        info.targettype = that.oneInfo.platname;
        if (that.amount * 1 > that.$store.state.userInfo.balance * 1) {
          //
          that.$parent.showTost(0, '操作金额超出了您的账户余额！');
          return;
        }
      }
      if (that.payType == 1) {
        //转出
        info.sourcetype = that.oneInfo.platname;
        info.targettype = 'userbalance';
        if (that.amount * 1 > that.oneInfo.balance * 1) {
          //
          that.$parent.showTost(0, '操作金额超出了您该游戏平台的余额！');
          return;
        }
      }
      that.$parent.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.$parent.showTost(1, res.message);

        if (res.code === 200) {
          that.hideShow();
          that.refreshusermoney();
          that.getbalancelists();
        } else {
          that.$parent.hideLoading();
        }
      });
    },
    hideShow() {
      this.show = false;
      this.amount = null;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.$parent.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    changVal(name, val) {
      let that = this;
      that[name] = val;
    },
    oneUpdate(val) {
      let that = this;
      that.oneInfo = val;
      that.show = true;
    },
    openList() {
      let that = this;
      that.shws = !that.shws;
      $('.list-wrap').toggleClass('list-wrap-extend').find('.list').slideToggle(200);
      $('.arrow-down').toggleClass('arrow-up');
    },
    changType(type) {
      let that = this;
      if (that.type == type) {
        return;
      }
      that.type = type;
      that.page = 1;
      that[`getList${type}`]();
    },
    getList0() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/gettransrecord', { api_type: that.api_type, date: that.date, page: that.page, type: 1 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.last_page = res.data.last_page;
            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getList1() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/gettransrecord', { api_type: that.api_type, date: that.date, page: that.page, type: 2 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.last_page = res.data.last_page;
            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getList2() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/gettransrecord', { api_type: that.api_type, date: that.date, page: that.page, type: 3 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.last_page = res.data.last_page;
            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getList3() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/gettransrecord', { api_type: that.api_type, date: that.date, page: that.page, type: 4 })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.last_page = res.data.last_page;
            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getBetInfo() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/betrecord', { api_type: '', date: that.date, page: that.page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.BetInfo = res.data.summary
          }

          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getList4() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/betrecord', { api_type: that.api_type, date: that.date, page: that.page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.last_page = res.data.last_page;
            if (that.page == 1) {
              that.list4 = res.data.list.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list4));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list4 = list;
            }
          }

          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getList5() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getfanshui', { api_type: that.api_type, date: that.date, page: that.page, type: '' })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }

          if (res.code == 200) {
            that.last_page = res.data.list.last_page;

            if (that.page == 1) {
              that.list5 = res.data.list.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list5));
              res.data.list.data.forEach(el => {
                list.push(el);
              });
              that.list5 = list;
            }
            that.jisuan = res.data.jisuan;
            that.nojisuan = res.data.nojisuan;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getList6() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun
        .post('/api/getTaskFlow', { api_type: that.api_type, date: that.date, page: that.page, type: '' })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }

          if (res.code == 200) {
            that.last_page = res.data.list.last_page;

            if (that.page == 1) {
              that.list5 = res.data.list.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list5));
              res.data.list.data.forEach(el => {
                list.push(el);
              });
              that.list5 = list;
            }
            that.jisuan = res.data.jisuan;
            that.nojisuan = res.data.nojisuan;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelists() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    getbalancelist() {
      let that = this;
      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.$parent.showTost(0, res.message);
            if (that.daoTime) {
              clearInterval(that.daoTime);
            }
            that.daoTime = null;
          }
          if (res.code === 200) {
            that.balancelist = res.data;
          }
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    Scroll1() {
      let that = this;
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // 变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      // 滚动条到底部的条件

      if (scrollTop + windowHeight === scrollHeight) {
        if (that.page < that.last_page) {
          that.page += 1;
          that[`getList${that.type}`]();

        }
        if (that.page == that.last_page) {
          that.$parent.showTost(0, '当前条件暂无新数据！');
        }
        // if (that.page <= that.page_total) {
        //   that.page += 1; // 页数+1 // 重新加载数剧
        //   that.gethomegoods();
        // }
        // // 数据全部加载完成
        // if (that.page > that.last_page) {
        // }
      }
    },
    Scroll(){
      let that = this;

       let scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
       let clientHeight = document.documentElement.clientHeight;
       let scrollHeight = document.documentElement.scrollHeight;
      //        console.log('动条滚动时，距离顶部的距离'+scrollTop)
      // console.log('可视区的高度'+clientHeight)
      // console.log('滚动条的总高度'+scrollHeight)
      //  if (scrollTop + clientHeight >= scrollHeight) {
       if (scrollTop + 20 >=clientHeight*that.page ) {

        if (that.page < that.last_page) {
          that.page += 1;
          that[`getList${that.type}`]();

        }
        // if (that.page == that.last_page) {
        //   that.$parent.showTost(0, '当前条件暂无新数据！');
        // }
       }
    }

  },
  mounted() {
    let that = this;
    window.addEventListener('scroll', this.Scroll, true);
    that.getBetInfo()
    // window.onscroll = function () {

    // };
  },
  updated() {
    let that = this;
    //展开资产详情
    // $('.arrow-down').click(function () {
    //   $('.list-wrap').toggleClass('list-wrap-extend').find('.list').slideToggle(200);
    //   $(this).toggleClass('arrow-up');
    // });
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
    window.removeEventListener('scroll', this.Scroll, true);
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-080bb754.bc0cc7c7.css';
.leftSpan {
  margin-right: 20px;
}
.hg {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hg input {
  flex: 1;
  height: 20px;
  line-height: 20px;
  outline: 0;
  background: #fff;
  border: 0;
  font-size: 14px;
  color: #333;
  padding-left: 6px;
}
.types {
  color: rgb(72, 32, 0);
  display: block;
  border-radius: 6px;
  text-align: center;
  padding: 0px 9px;
  font-size: 12px;
  // background: #333;
  color: #999;
  margin-right: 10px;
}
.types.active {
  background-image: linear-gradient(90deg, rgb(254, 203, 77), rgb(255, 223, 144));
  color: #482000;
}
.popup-background[data-v-710c460e] {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
}
.assetDetails .content .list .tab a[data-v-abca6e38][data-v-05a2a38e],
.assets .content .list .tab a[data-v-abca6e38][data-v-05a2a38e] {
  margin-right: 6px;
}

.assetDetails .content .list .c[data-v-3acb7497],
.assets .content .list .c[data-v-3acb7497] {
  background: #222;
  border-radius: 4px;
  padding: 0 15px;
  position: relative;
}
.assetDetails .content .list .c[data-v-73a82902],
.assets .content .list .c[data-v-73a82902] {
  background: #222;
  border-radius: 4px;
  padding: 0 15px;
  position: relative;
}
.assetDetails .content .list .c .flex-group[data-v-73a82902],
.assets .content .list .c .flex-group[data-v-73a82902] {
  height: 68px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid rgba(58, 58, 58, 0.5);
}

.assetDetails .flex-group[data-v-73a82902],
.assets .flex-group[data-v-73a82902] {
  position: relative;
}
.assetDetails .content .list .c .flex-group .item[data-v-73a82902],
.assets .content .list .c .flex-group .item[data-v-73a82902] {
  display: inline-block;
  position: relative;
}
.assetDetails .content .list .c .flex-group .item .checkbox[data-v-73a82902],
.assets .content .list .c .flex-group .item .checkbox[data-v-73a82902] {
  width: 20px;
  height: 20px;
  position: relative;
}
.assetDetails .content .list .c .flex-group .item .checkbox input[data-v-73a82902],
.assets .content .list .c .flex-group .item .checkbox input[data-v-73a82902] {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  border: 0;
  opacity: 0;
  margin: 0;
  z-index: 100;
}
.assetDetails .content .list .c .flex-group .item .checkbox .check[data-v-73a82902],
.assets .content .list .c .flex-group .item .checkbox .check[data-v-73a82902] {
  width: 100%;
  height: 100%;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCCAYAAAGUUzB+AAAAAXNSR0IArs4c6QAABYZJREFUeAHtW0toHVUYntzc5HbR7nRTBLuwLYjiIpAIKi5cSMFSWgsScOEquUnMxtS12blosopJbrLqQgjSx0ah1J20gjcmC0ELURcqYjauNAtvcpP4fYf5Ts7Jfacz05twBobzz3n8j2/+8/xnoiizq1gsTufakZZxpXZUinpUi1aIVloqlWryVOanIyMj+37OwZMpq8f+oEoUtcQmiwp7e3ufuEq59Ojo6H8GrLGxsTf29/ffcgvxvLG0tLRi0aTNPT09j3HfdivWo9H4Au7h5eVl2z6CuJ/qVW4njxoauNqR3oghTWyJeaPGbn6XMSHarnqd0Gi7Yes3c3lbySHoQLhvOllHJ42jgFsRKi2CzWwul9tqxY7uDZeowlP7TF2Y8F2rRofLJycnC2j3MOrUfpcR2z6xXwQGbQybLur16AAiQMR1eWJi4vl6ALWdR5/GPdNug/Hx8RfUhw7GfbRG5hQ0OtOKUV9f36dzc3MV1vMYqCEY3QH9rp6TSjGGbOEexvLgK5enVcIZmMqY1V51KyVJ853t7Oz8Rp7e7EnLhW2SApvxgrwZyVSvIvSzzRolXQYUbpAnFJmSEvTvlnND0oqQH53YKpGGgHZ5BiWEVEAiICEElHaPT3BiabYHk8ZJppyGyY+zqTuB7WBlnS8UCqc0xSYp1OWFyfI2ZF3P5/ODCwsL31slVAlj+UPQr+s5jRRD9RCm89U0eB+ZZw0SOER4B1Ct4D59ZK6NG97F7Hn9cLGnBN6V8QtWgrOu4P75cIOjPMPpT4PXJRj2Ysx7DLu0knhZJbTAgLeem5+f/10Vkk4hhzvDIShlFTHjROyMEXtGmgrQoHjpWAYq3OOaS4MVe8Ns2l0zlilFuKrigjrK8YSFhJZbpLO48DoeQ45Z0ed2d3cHsxB6WAZex33lYdxovVFR5SRTyLVrWvlEkvw75hWUEGQBiYCEEFAafCIgIQSUBp8ISAgBpcEnLBJYZh0Em5SbQQq5NkCW6+/vv0eZ2iVnIN+IgBLDWOyaJV5Oy3wseH/MSgGFA6DEMGUax+QuGZoVuGVPWxHG2Xi2DQWqOmi320AocBOK3EBhpbe39yWcG/yatELY7DCWMUW+2OdY2ZZgAXbkg9i8lkmneD2CAmbDJRmeEsqcnp4+tbm5eRWoXFTek6Qw7F+gu7q4uMgDmJqrrhI1teIMvs9qtUq0nsOrO/u0Nk6N9KOxAO4v6PUnjqJW1eka1XfzmwIRuwjDIKkeYbkKpUQ/AjAf8YyuEf+6QKizqhE7LTzgMzArpdFxJSfJlOM/vLcI3T/kCCjeeJ7BQdXHelbqAUEPQKNvcedZAY3uYGJ5vxMXE+NuStmlt7e3P4dd5tgQdlVxv+YepFogeHaJPvZlDEAFb/9i2gdoWYPFSRNesiEPwVhy2Zu7YsT+RgVzgAsQzh+XLtApmHGX+SV+4Vvw+Gfo8WYlAbe5JhDgMisnFQQaT9toI2naTNtJGyBQYOdq0ImcppN5t16ujbK9KzY93QBYACJ+CwGIAITfIYNHBI8IHuEjEDzCxyOMEcEjgkf4CASP8PEIY0TwiOARPgLBI3w8whjhegQDI8IHdBofnop9V6SujTiu+4dKGY9gKEwa4ujqkuiTmro24iTbBH16aeza2tofAwMDL4Pk17rPgj6zvr7+NctO2hVHga/Edt1FsIdRYf+Hs/ijYIX3yvg4+M3jHtzRi2TIolKpfIPnoTjPi0bbAI8aINynv3KVVcbn2u8d12BP/JPdFw4AjODZz8JlZA0QKiAgoOcwmJjwn/LBhB8z/4B8Rp3t57wqf5opB0HodxY6vAL9zEf50gf5VdCT7gf6KmPaEAi3UhwO/ADM3oaAYzGrQNct6PoAL+uWwnquTYFugMD/V4UWCZ3LxIUAAAAASUVORK5CYII=)
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.assetDetails .content .list .c .flex-group .item .bankcard[data-v-73a82902],
.assets .content .list .c .flex-group .item .bankcard[data-v-73a82902] {
  width: 36px;
  height: 36px;
  display: block;
}

.icon_weixin[data-v-73a82902] {
  background-position: -72.8px 0;
}
.icon_weixin[data-v-73a82902],
.icon_zhifubao[data-v-73a82902] {
  width: 36.4px;
  height: 36.4px;
  background-image: url(/static/image/deposit_icons.669e4d3f.png);
  background-repeat: no-repeat;
  background-size: 259px 109.2px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p.txt-bold[data-v-73a82902],
.assets .content .list .c .flex-group .item p.txt-bold[data-v-73a82902] {
  color: #fff;
}

.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p.payType[data-v-73a82902],
.assetDetails .content .list .c .flex-group .item p .requestId[data-v-73a82902],
.assets .content .list .c .flex-group .item p.payType[data-v-73a82902],
.assets .content .list .c .flex-group .item p .requestId[data-v-73a82902] {
  font-size: 12px;
  line-height: 16px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .content .list .c .flex-group .item p[data-v-73a82902],
.assets .content .list .c .flex-group .item p[data-v-73a82902] {
  font-size: 14px;
  color: #999;
  line-height: 22px;
}
.assetDetails .list-wrap .list .flex-group[data-v-abca6e38][data-v-05a2a38e],
.assets .list-wrap .list .flex-group[data-v-abca6e38][data-v-05a2a38e] {
  height: auto;
  border-bottom: 1pxsolidrgba (0, 0, 0, 0.15);
  width: 33%;
  padding: 0 15px;
  display: inline-block;
}

.btne {
  background-image: linear-gradient(90deg, rgb(254, 203, 77), rgb(255, 223, 144));
  color: rgb(72, 32, 0);
  margin: 6px auto;
  display: block;
  border-radius: 6px;
  text-align: center;
  width: 65%;
  font-size: 12px;
}
.assetDetails .list-wrap .list .flex-group .item p[data-v-abca6e38][data-v-05a2a38e],
.assets .list-wrap .list .flex-group .item p[data-v-abca6e38][data-v-05a2a38e] {
  font-size: 12px;
  color: #fff;
  line-height: 22px;
}
.assetDetails .banner[data-v-abca6e38],
.assets .banner[data-v-abca6e38] {
  padding: 59px 0 0px;
}
.qiehuan {
  color: #fecb4d;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid #fecb4d;
  padding: 4px 0;
  width: 100px;
  position: absolute;
  top: 20px;
  right: 5px;
}
.qiehuan img {
  width: 18px;
  margin-right: 4px;
}
.assetDetails .content .list .c,
.assets .content .list .c {
  padding: 0 6px !important;
}
.assetDetails .content .list .c .flex-group,
.assets .content .list .c .flex-group {
  height: 88px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/assets.vue